<template>
  <div class="p-1">
    <div-table
      :config="configList"
      :data="salaries"
      :idWharhouse="idWharhouse"
      :currentUser="currentUser"
      :limit="limit"
      @reset="reset"
      @refresh="refresh"
      @filtrer="filtrer"
      @search="search"
      :loading="loading"
      :paginate="paginate"
      @paginatation="paginatation"
      @Changelimit="Changelimit"
    ></div-table>
  </div>
</template>

<script>
import config from "./config";
export default {
  props: {
        currentUser: { type: Object},
        idWharhouse: { type: Object}
  },
  data() {
    return {
      configList: config.list,
      loading: false,
      formData: {},
      salaries: [],
      sellers: [],
      tabId:[],
      limit: 10,
      filters:{},
      paginate: {
        total: 0,
        currentpage: 1,
        lastpage: 0,
        per_page: 0,
      },
    };
  },
  computed: {
    warhouseSelected(){
            return this.$store.getters["wharhouse/warhouseSelected"]({user:_.pick(this.currentUser,['countries'])})
    },
  }, 
  watch: { 
      'warhouseSelected': async function(oldVal, newVal) {

      },
      'idWharhouse': async function(oldVal, newVal) {
          this.idWharhouse=oldVal;  
          await this.reset();
          await this.getSellers();
          this.setDataSelect("seller", this.sellers, null)
      }
},
async mounted() {
    if(this.$f.QueryStringToobject()) this.filters=this.$f.QueryStringToobject();
    else this.$f.objectToQueryString({limit:this.limit,country:this.idWharhouse.country})

    if(this.filters.name) await this.search(this.filters.name);
    else await this.getSalaries(this.filters);

    await this.checkDataFilters();

  },
  methods: {
    async getwharhouseId(){
       await this.$store.dispatch('wharhouse/getwharhouseId',{country: this.warhouseSelected,}).then((res) => {this.idWharhouse=res;})
    },
     setDataSelect(model, data,splice=null,rangeDate=null) {
      for (var i = 0; i < this.configList.filters.elements.champs.length; i++) {
        if(rangeDate){
            if(this.configList.filters.elements.champs[i].key === 'Range_date') this.configList.filters.elements.champs[i].value = data;
        }else{
            if (this.configList.filters.elements.champs[i].type === "select" && this.configList.filters.elements.champs[i].key === model) {
              if (!splice) this.configList.filters.elements.champs[i].values = data; 
              else  this.configList.filters.elements.champs.splice(i, 1);
            }
        }
       
      }
    },
    async getSellers() {
      const filter = {
         type: "Seller",
         countries:this.idWharhouse.country,
         limit:10,
      };
       if (this.currentUser.type != "Seller") {
          const res = await this.$server.search("users", filter);
          if (res.content.results) this.sellers = res.content.results;
          else this.sellers = [];
       }
    },
    async Changelimit(val){
       if(this.$f.QueryStringToobject()) this.filters=this.$f.QueryStringToobject();
       this.filters['limit']=val;
       this.filters['page']=1;
       this.paginate.currentpage=1;
       this.$f.objectToQueryString(this.filters)
       if(this.filters.name) await this.search(this.filters.name);
       else this.getSalaries(this.filters);
    },
    async filtrer(data) {
       if(this.$f.QueryStringToobject()) this.filters=this.$f.QueryStringToobject();
       delete  this.filters.page;
       delete  this.filters.name;

       console.log('filter search________',data)
       this.paginate.currentpage=1;
       if(!this.filters['limit']) this.filters['limit']=this.limit;
       if(data.user)  {this.filters['user._id']=data.user._id;}else delete this.filters['user._id'];
       if(data.type)  {this.filters['user.type']=data.type;}else delete this.filters['user.type'];
       if(data.Range_date && data.Range_date[0]){this.filters.Range_date=data.Range_date.map( el => this.$moment(el).format('yyyy-MM-DD'));}else delete this.filters.Range_date;
       this.$f.objectToQueryString(this.filters)
      await this.getSalaries(this.filters);
    },
    /**********************************User and Status******************************************************/
   
    async reset() {
        let lmitt=this.limit;
        if(this.$f.QueryStringToobject()) this.filters=this.$f.QueryStringToobject();
        if(this.filters['limit']) lmitt=this.filters['limit'];
        this.filters['page']=1;
        this.$f.objectToQueryString({limit:lmitt,country:this.idWharhouse.country})
        await this.getSalaries( {limit:lmitt});
    },
    async refresh() {
        if(this.$f.QueryStringToobject()) this.filters=this.$f.QueryStringToobject();
        this.$f.objectToQueryString(this.filters)
        if(this.filters.name) await this.search(this.filters.name);
        else await this.getSalaries(this.filters);
       if(this.filters['page'] && this.filters['page']>1 && this.salaries.length==0){
           this.filters['page']= --this.filters['page'];
           this.$f.objectToQueryString(this.filters)
           await this.getSalaries(this.filters);
       }
    },
    async getSalaries(filters) {
      this.loading = true;
      filters['country']=this.idWharhouse.country;
      const res = await this.$server.search("salaries", filters);
      this.loading = false;
      console.log('res salaries----',res)

      if (res && res.content.results) {
        this.salaries = res.content.results;

        for (const element of  this.salaries) {
          element.amount= this.checkAmount(element).toFixed();
        }

        console.log('res salaries 22----',this.salaries)

        this.paginate.total = res.content.total;
        this.paginate.lastpage = res.content.last_page;
        this.paginate.per_page = res.content.per_page;
        this.paginate.currentpage = res.content.current_page;
      } else {
        this.salaries = [];this.paginate={total: 0,currentpage: 1,lastpage: 1,per_page: 0,}
      }

     
    },
    checkAmount(sal){
        let data= sal.fees.reduce((total, fees) => {
            if (fees.is_deduction) {
                return parseFloat(total) - parseFloat(fees.amount);
            } else {
                return parseFloat(total) + parseFloat(fees.amount);
            }
        }, 0);
        if(isNaN(data)) data=0;

        return (parseFloat(sal.salary) - parseFloat(sal.absentAmount)) + data;
    },
    getElementInArray(data,value){
      var result  = data.filter(function(o){
          let whar=o.warehouse;
          if(o.warehouse._id) whar=o.warehouse._id;
          return whar == value.toString();
      } );
      return result? result[0] : null; // or undefined
    },

    async checkDataFilters(){
      const {content:data} = await this.$server.get("settings");
      const currentSettingW= this.getElementInArray(data.details,this.idWharhouse._id);
      this.typeEmployeurs=currentSettingW.salaries.map(el => el.type);

      const {content:res} = await this.$server.search("users", {type:this.typeEmployeurs,countries:this.idWharhouse.country});
        if (res.results) {
          this.sellers = res.results;
        }else this.sellers = [];

      this.setDataSelect('type',this.typeEmployeurs,null); 
      this.setDataSelect('user',this.sellers,null); 
      //this.setDataSelect(null,[this.$moment(new Date(this.$moment().startOf('month').format('YYYY-MM-DD hh:mm')), 'LL').toDate(),this.$moment(new Date(this.$moment().endOf('month').format('YYYY-MM-DD hh:mm')), 'LL').toDate()],null,'Range_date'); 

      
      
    },

    async search(data) {
       this.paginate= {total: 0,currentpage: 1,lastpage: 1,per_page: 0,};
       let limitt=this.limit
       if(this.filters['limit']) limitt=this.filters['limit'];
       

       const search = {
          name:data.trim(),
          limit:parseInt(limitt),
          'country':this.idWharhouse.country,
          Range_date:this.filters['Range_date']
       }

     this.$f.objectToQueryString(search)
     const  res = await this.$server.find("salaries", search);
       if (res.content.results) {
        this.salaries = res.content.results; 
        for (const element of  this.salaries) {
          element.amount= this.checkAmount(element).toFixed();
        }

        this.paginate.total = res.content.total;
        this.paginate.lastpage = res.content.last_page;
        this.paginate.per_page = res.content.per_page;
        this.paginate.currentpage = res.content.current_page;
      } else {
        this.salaries = [];this.paginate={total: 0,currentpage: 1,lastpage: 1,per_page: 0,}
      }
        
    },
    async remove(id) {
      this.$confirm("You want to delete this avoir?").then(async (res) => {
        if (res) {
          const resp = await this.$server.delete("salaries", { id: id });
          await this.refresh();
          alert("avoir Deleted", "success");
        }
      });
    },
    /********************************************************************************************/
    async paginatation(direction) {
      var page = 0;
      if (direction == "next") {
        page = ++this.paginate.currentpage;
      } else {
        page = --this.paginate.currentpage;
      }
      if(this.$f.QueryStringToobject()) this.filters=this.$f.QueryStringToobject();
      this.filters['page']=page;
      this.$f.objectToQueryString(this.filters)

      this.getSalaries(this.filters);
    },
  },
};
</script>

<style>
/* animation for vue transition tag */

</style>
